<template>
	<div class="smpImport">
		<p class="smpImport_header">
			<router-link tag="i" to="SampleManagement" class="icon wjpc-iconfont wjpc-icon-arrow-left-bold"></router-link>
			<span>样本管理</span>
		</p>
		<div class="smpImport_bread"><span>样本导入</span></div>
		<div class="smpImport_content">
			<div class="smpImport_content_a">
				<span class="content_a_left">
					<!-- 上 -->

					<el-upload class="upload-demo" ref="upload" :action="$config.service.uploadsample" :http-request="upload" :auto-upload="true" :multiple="false" :limit="1">
						<span class="upload-demo_span">选择要导入的样本文件</span>
						<el-button slot="trigger" type="primary">选取文件</el-button>

						<div slot="tip" class="el-upload__tip">只能上传excel文件</div>
					</el-upload>
				</span>
			</div>
			<div class="smpImport_content_b">
				<span class="smpImport_content_b_span">样本数据预览</span>
				<el-button type="primary" @click="addfiletitle" :loading="loading">导入样本</el-button>
			</div>
			<div class="smpImport_content_c">
				<div class="content_c_left">
					<p class="content_c_pheader">源字段</p>
					<div class="primitive" v-for="item in excelHeaders" :key="item">
						<span>{{ item }}</span>
					</div>
				</div>
				<!-- 目标字段 -->
				<div class="content_c_right">
					<p class="content_c_pheader">目标字段</p>
					<div class="target" v-for="(item, index) in excelToTarget_dom" :key="index">
						<span>{{ item.zhField }}</span>
						<!-- <i class="icon iconfont iconico_open"></i> -->
						<el-dropdown @command="command => handleIndex(command, index)">
							<span class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i></span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="item in targetOptions" :key="item.id" :command="item">{{ item.zhField }}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			excelName: '',
			excelHeaders: [],
			targetHeaders: [],
			targetOptions: [],
			excelToTarget: [],
			excelToTarget_dom: [],
		};
	},
	methods: {
		language() {
			return window.localStorage.getItem('lang') || this.$defaultLang
		},
		submitUpload() {
			this.$refs.upload.submit();
		},
		addfiletitle() {
			this.loading = true;
			let sampleContrastList = this.excelToTarget.filter(item => item.enField != 'ignore');
			let token = localStorage.getItem('token');
			sampleContrastList = sampleContrastList.map(item => {
				return {
					sfield: item.enField,
					tfield: item.zhField
				};
				
			});

			let data = {
				questionnaireId: sessionStorage.getItem('wid'),
				sampleContrastList: sampleContrastList,
				sampleDataName: this.excelName
			};
			this.$axios({
				url: this.$config.service.addfiletitle,
				method: 'POST',
				data: data,
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
					Authorization: token ? 'Bearer ' + token : '',
					'Accept-Language': this.language(),
				}
			})
				.then(res => {
					if (res.status == 200 && res.data.code == 0) {
						this.loading = false;
						this.$message.success(res.data.message);
						this.$router.push('/SampleManagement');
					} else {
						this.loading = false;
						this.$message.error(res.data.message);
					}
				})
				.catch(error => {
					this.$message.error(res.data.message);
				});
		},
		upload(options) {
			let formData = new FormData();
			formData.append('multipartFile', options.file);
			let token = localStorage.getItem('token');
			this.$axios({
				url: this.$config.service.uploadsample,
				method: 'POST',
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data',
					Authorization: token ? 'Bearer ' + token : '',
					'Accept-Language': this.language(),
				}
			})
				.then(res => {
					console.log(res);
					if (res.status == 200 && res.data.code == 0) {
						this.$message.success(res.data.message);
						this.excelName = res.data.resultBody.sampleDataName;
						this.excelHeaders = res.data.resultBody.sampletitleList;
						this.load_target_headers();
					} else {
						this.$message.error(res.data.message);
					}
				})
				.catch(error => {
					this.$message.error(res.data.message);
				});
		},
		load_target_headers() {
			let token = localStorage.getItem('token');
			this.$axios({
				url: this.$config.service.queryquestionnairetitle,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
					Authorization: token ? 'Bearer ' + token : '',
					'Accept-Language': this.language(),
				},
				data: {
					id: sessionStorage.getItem('wid')
				}
			})
				.then(res => {
					if (res.status == 200 && res.data.code == 0) {
						this.targetHeaders = res.data.resultBody.datas;
						this.targetOptions = JSON.parse(JSON.stringify(this.targetHeaders));

						for (let i = 0; i < this.excelHeaders.length; i++) {
							let found = false;
							for (let j = 0; j < this.targetOptions.length; j++) {
								if (this.excelHeaders[i] == this.targetOptions[j].zhField) {
									this.$set(this.excelToTarget, i, this.targetOptions[j]);
									found = true;
								}
							}
							if (!found) {
								this.$set(this.excelToTarget, i, {
									zhField: this.excelHeaders[i],
									enField: ''
								});
								this.targetOptions.push({
									zhField: this.excelHeaders[i],
									enField: ''
								});
							}
						}
						this.targetOptions.push({
							zhField: '忽略此字段',
							enField: 'ignore'
						});
						this.excelToTarget_dom = JSON.parse(JSON.stringify(this.excelToTarget));
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		handleIndex(command, index) {
			for (let i = 0; i < this.excelToTarget.length; i++) {
				if (i != index && command.zhField != '忽略此字段' && command.zhField == this.excelToTarget_dom[i].zhField) {
					this.$message.error('不可选择重复字段哦');
					return;
				}
			}
			let _item = {
				enField:command.enField,
				zhField:this.excelHeaders[index]
			}
			this.$set(this.excelToTarget, index, _item);
			this.$set(this.excelToTarget_dom, index, command);
		}
	}
};
</script>

<style lang="scss">
html {
	background-color: #f5f5f5;
}
.smpImport {
	width: 100%;
	height: 100%;
	background-color: #f5f5f5;
	// 头部
	.smpImport_header {
		height: 68px;
		background-color: #fff;
		text-align: center;
		line-height: 68px;
		i {
			float: left;
			margin-left: 30px;
			font-size: 16px;
		}
		span {
			font-size: 16px;
			color: #333;
		}
	}
	.smpImport_bread {
		max-width: 1200px;
		height: 69px;
		line-height: 69px;
		margin: auto;
	}
	.smpImport_content {
		max-width: 1200px;
		background-color: #fff;
		margin: auto;
		.smpImport_content_a {
			max-width: 840px;
			padding-left: 30px;
			height: 160px;

			border-bottom: 1px solid #e4eeda;
			display: flex;
			justify-content: space-between;
			.content_a_left {
				margin-top: 35px;
				.upload-demo {
					.upload-demo_span {
						float: left;
						line-height: 40px;
						font-size: 16px;
						color: #333;
						margin-right: 5px;
					}
				}
			}
			.content_a_right {
				line-height: 160px;
			}
		}
		.smpImport_content_b {
			max-width: 840px;
			padding-left: 30px;
			height: 80px;
			line-height: 80px;
			display: flex;
			justify-content: space-between;
			.smpImport_content_b_span {
				font-size: 16px;
				color: #333;
			}
			.el-button {
				width: 120px;
				height: 36px;
				font-size: 16px;
				color: #fff;
				margin-top: 18px;
			}
		}
		.smpImport_content_c {
			max-width: 840px;
			height: 545;
			overflow-y: auto;
			padding-left: 30px;
			display: flex;
			justify-content: space-between;
			padding-bottom: 100px;
			.content_c_left {
				width: 820px;
				.content_c_pheader {
					height: 42px;
					line-height: 42px;
					background-color: #f5f5f5;
					font-size: 16px;
					color: #333;
					text-align: center;
				}
				.primitive {
					height: 40px;
					line-height: 40px;
					font-size: 14px;
					border: 1px solid #e1e1e1;
					border-top: none;
					background-color: #ffffff;
					display: flex;
					justify-content: space-between;
					span {
						padding-left: 20px;
					}
					i {
						padding-right: 30px;
					}
				}
			}
			.content_c_right {
				width: 820px;
				.content_c_pheader {
					height: 42px;
					line-height: 42px;
					background-color: #f5f5f5;
					font-size: 16px;
					color: #333;
					text-align: center;
				}
				.target {
					height: 40px;
					line-height: 40px;
					font-size: 14px;
					border: 1px solid #e1e1e1;
					border-top: none;
					background-color: #ffffff;
					display: flex;
					justify-content: space-between;
					span {
						padding-left: 20px;
					}
					i {
						padding-right: 30px;
					}
				}
			}
		}
	}
}
</style>
